export const currentYear = new Date().getFullYear();
export const activeYear = currentYear + 1;
